





import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import DataType from "../../../../Functions/Traitement/DataperiodMCompteRegpt";
import DataType2 from "../../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataType3 from "../../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataType4 from "../../../../Functions/Traitement/DataperiodMCompteRegpt4";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import SearchModal from "../../../SearchModal";
import InputForm from "../../../InputT";
import SelectOption from "../../../SelectOption";
import DataSelect from '../../../../Types/DataSelect'
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SearInputG from "../../../SearchInput"
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate'
import Demand from '../../../../Models/MComptesRegroup';
import Demande from '../../../../Models/McomptesPretEtDecouvert';
import Demande2 from '../../../../Models/MComptesOperatSysteme';
import formatDate from "../../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodLimite";
import DataPeriod2 from "../../../../Functions/Traitement/DataperiodMCompteRegpt2";
import DataPeriod3 from "../../../../Functions/Traitement/DataperiodMCompteRegpt3";
import DataPeriod4 from "../../../../Functions/Traitement/DataperiodMCompteRegpt4";




const VisualLimite = () => {
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Ttable, SetTtable] = useState("")
    const [Nnum, SetNnum] = useState("")
    const [Colon, setColon] = useState("")
    const [Columm, setColumn] = useState<any>()

    const [donnees, setData] = useState<any[]>([]);
    const onChange = (e: CheckboxChangeEvent) => {
        console.log(`checked = ${e.target.checked}`);
    };

    // usestate pour la recherche 
    const [SearchR, SetSearchR] = useState<string>("");




    const dataOption2: DataSelect[] = [
        { label: " Toutes Les Limites ", value: " " },
        { label: " Limites avec Niveaux Consommations = 0 ", value: "1" },
        { label: " Limites avec Niveaux Consommations > 0 ", value: "2" }
    ]


    // DECLARATION DES COLONNES DU TABLEAU
    const columns1: ColumnsType<DataType> = [
        {
            title: 'Id limite',
            dataIndex: 'idlimite',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.idlimite)
                    .toLowerCase()
                    .includes(value.toLowerCase())
                //||
                // String(record.codage)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NUMCPT)
                //     .toLowerCase()
                //     .includes(value.toLowerCase()) ||
                // String(record.NOMCPT)
                //     .toLowerCase()
                //     .includes(value.toLowerCase())
            }

        },
        {
            title: 'Montant limite',
            dataIndex: 'mntlimite',
        },
        {
            title: 'Niveau conso',
            dataIndex: 'nivcons',
        },
        {
            title: 'Date début',
            dataIndex: 'datedebut',
        },
        {
            title: 'Date fin',
            dataIndex: 'datefin',
        },
        {
            title: 'Uyilisateur',
            dataIndex: 'utisai',
        },
        {
            title: 'Agence',
            dataIndex: 'codeage',
        },
        {
            title: 'Motif',
            dataIndex: 'Motif',
        }
    ];


    function Getselectcli() {

    }


    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Visulaisation limite
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >

                            <legend style={{ textAlign: "center", paddingLeft: 10, borderRadius: 10 }} > Interface Visulaisation Limite </legend>

                            <Box className='border' style={{ marginTop: -10, display: 'flex' }} sx={{ mb: 1 }}>
                                <Box style={{ textAlign: "center",width: '100%' }}  >
                                    <Form.Item style={{ width: '100%' }} >
                                        < SelectOption onchange={Getselectcli} disabled={false} Option={dataOption2} width={0} label="Catégorie" Size={'100%'} name="categorie" />
                                    </Form.Item>
                                </Box>
                                <Box style={{ width: '100%',  }}  >
                                    <InputForm notRequired disabled={false} onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} name="Element" type="string" />
                                </Box>

                            </Box>
                              <Box className='border'   fontStyle="inherit" >
                                 <Spin spinning={loading}>
                                    <Table dataSource={donnees} style={{ textAlign: "center", width: '100%' }} columns={columns1} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                 </Spin>
                                </Box>
                            
                        </Box>
                    </div>
                </div >
            </>,
        }
    ];


    function consult() {



    }


    // function Onfinish
    const onFinish = (values: any) => {

        let codeage = Perss.codage;
        let dataAgence = Crypter.encrypt(codeage)

        if (sbmit == 'Consult') {

            if (form.getFieldValue("categorie") == " ") {
                // ********************* 0 **************************************************
                let dataCh = Crypter.encrypt(form.getFieldValue("categorie"))
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.AllVisualLimite,
                    headers: {
                        'Cypherchoix': dataCh,
                        'Cyphercodage': dataAgence,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {

                            let datas = response.data.Result;
                            
                            if(datas == null){
                                SweetAlert.fire({ text: "Il ne possédent aucun enregistrement", icon: "warning" })
                            }else{
                                datas.map((val: any, key: any) => {
                                    dat.push({
                                        key: key,
                                        idlimite: val.idlimite,
                                        mntlimite: val.mntlimite,
                                        nivcons: val.nivcons,
                                        datedebut: val.datedebut,
                                        datefin: val.datefin,
                                        utisai: val.utisai,
                                        codeage: val.codeage,
                                        Motif: val.Motif
                                    }
                                    )
                                })
                                setData(dat);
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });

            } else if (form.getFieldValue("categorie") == "1") {
                // ********************* 1 **************************************************
                let dataCh = Crypter.encrypt(form.getFieldValue("categorie"))
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.AllVisualLimite,
                    headers: {
                        'Cypherchoix': dataCh,
                        'Cyphercodage': dataAgence,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {

                            let datas = response.data.Result;
                            
                            if(datas == null){
                                SweetAlert.fire({ text: "Il ne possédent aucun enregistrement", icon: "warning" })
                            }else{
                                datas.map((val: any, key: any) => {
                                    dat.push({
                                        key: key,
                                        idlimite: val.idlimite,
                                        mntlimite: val.mntlimite,
                                        nivcons: val.nivcons,
                                        datedebut: val.datedebut,
                                        datefin: val.datefin,
                                        utisai: val.utisai,
                                        codeage: val.codeage,
                                        Motif: val.Motif
                                    }
                                    )
                                })
                                setData(dat);
                            }
                           
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });

            } else if (form.getFieldValue("categorie") == "2") {
                // ********************* 2 **************************************************
                let dataCh = Crypter.encrypt(form.getFieldValue("categorie"))
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.AllVisualLimite,
                    headers: {
                        'Cypherchoix': dataCh,
                        'Cyphercodage': dataAgence,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                // MAPPING DANS LE TABLEAU
                let dat: DataPeriod1[] = [];

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {

                            let datas = response.data.Result;
                            if(datas == null){
                                SweetAlert.fire({ text: "Il ne possédent aucun enregistrement", icon: "warning" })
                            }else{
                                datas.map((val: any, key: any) => {
                                    dat.push({
                                        key: key,
                                        idlimite: val.idlimite,
                                        mntlimite: val.mntlimite,
                                        nivcons: val.nivcons,
                                        datedebut: val.datedebut,
                                        datefin: val.datefin,
                                        utisai: val.utisai,
                                        codeage: val.codeage,
                                        Motif: val.Motif
                                    }
                                    )
                                })
                                setData(dat);
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }

        }

    }



    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir le champs obligatoire", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir le champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { setSbmit("Consult") }} type="ghost" htmlType="submit" block  >
                                    Consulter
                                </Button>
                                <Button size='large' disabled={false} onClick={() => { form.resetFields(); setData([]); SetTtable(""); SetNnum(""); setColumn("") }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default VisualLimite;